<template>
  <div id="app">
    <Cover />
    <Content />
  </div>
</template>

<script>
import Cover from "./components/Cover";
import Content from "./components/Content";

export default {
  name: "App",
  components: {
    Cover,
    Content
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap");
body {
  margin: 0;
  padding: 0;
  background-color: #f6f6f6;
}
#app {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f6f6f6;
}
a {
  text-decoration: none;
  color: black;
  font-weight: 700;
}
</style>
